import priceRecords from './PriceRecords'

export default [
  ...priceRecords,
]
